import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Label from '../../atoms/display/Label'
import FieldView from '../../molecules/display/FieldView'
import { ClientDetail } from '../../../types/Company'

type Props = {
  clientDetail: ClientDetail
}

function accountTypeName(value?: number | null) {
  switch (value) {
    case 1:
      return '普通'
    case 2:
      return '当座'
    default:
      return '-'
  }
}

export default function ClientBankAccountView({ clientDetail }: Props) {
  return (
    <FlexColumn>
      <FlexRow>
        <FieldView label="銀行コード">
          <Label text={clientDetail.bankCode ?? '-'} />
        </FieldView>
        <FieldView label="銀行名">
          <Label text={clientDetail.bankName ?? '-'} />
        </FieldView>
      </FlexRow>
      <FlexRow>
        <FieldView label="支店コード">
          <Label text={clientDetail.branchCode ?? '-'} />
        </FieldView>
        <FieldView label="支店名">
          <Label text={clientDetail.branchName ?? '-'} />
        </FieldView>
      </FlexRow>
      <FlexRow>
        <FieldView label="口座種別">
          <Label text={accountTypeName(clientDetail.accountType)} />
        </FieldView>
        <FieldView label="口座番号">
          <Label text={clientDetail.accountCode ?? '-'} />
        </FieldView>
      </FlexRow>
      <FieldView label="口座名義">
        <Label text={clientDetail.accountOwner ?? '-'} />
      </FieldView>
    </FlexColumn>
  )
}
